import { render, staticRenderFns } from "./activar_desactivar_reportesemanal.vue?vue&type=template&id=24294d39"
import script from "./activar_desactivar_reportesemanal.vue?vue&type=script&lang=js"
export * from "./activar_desactivar_reportesemanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports